import React, { useState } from 'react';
import styles from "./Button.module.css";
import Popped from '../poppedUpWindow/Popped';

const Button = (props) => {
  const [isPoppedOpen, setIsPoppedOpen] = useState(false);

  const handleButtonClick = () => {
    setIsPoppedOpen(true);
  };

  return (
    <>
      <div className={styles.center}>
        <button className={styles.button} onClick={handleButtonClick}>
          <span className={styles.buttonContent}>
            {props.text}
          </span>
          <div className={styles.shine}></div>
        </button>
      </div>
      
      {isPoppedOpen && <Popped onClose={() => setIsPoppedOpen(false)} />}
    </>
  );
};

export default Button;